import { render, staticRenderFns } from "./TemplateOne.vue?vue&type=template&id=9c49f8ae&scoped=true"
import script from "./TemplateOne.vue?vue&type=script&lang=js"
export * from "./TemplateOne.vue?vue&type=script&lang=js"
import style0 from "./TemplateOne.vue?vue&type=style&index=0&id=9c49f8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c49f8ae",
  null
  
)

export default component.exports